import { useCallback } from "react";

import { VoucherLimitType } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import * as Shared from "../../../../../_shared";

const voucherLimitTypeOptions: FormOptionType[] = [
	{
		id: "voucherLimitTypeOptions_0",
		label: "有効になるまでの期間",
		value: VoucherLimitType.Interval,
	},
	{
		id: "voucherLimitTypeOptions_1",
		label: "チェックイン可能な期間",
		value: VoucherLimitType.StayDate,
	},
];

export const useVoucherLimitType = () => {
	const { viewModel, onSetViewModel } = Shared.Model.Context.useMarketingVoucherEditContext();
	const { voucherLimitType } = viewModel;

	const onSetVoucherLimitType = useCallback(
		(input: string) => {
			onSetViewModel([
				{
					key: "voucherLimitType",
					value: {
						...voucherLimitType,
						value: input as VoucherLimitType,
					},
				},
			]);
		},
		[onSetViewModel, voucherLimitType],
	);

	return {
		voucherLimitTypeOptions,
		voucherLimitType,
		onSetVoucherLimitType,
	};
};
